/**
 * Stock Chart Viewer - API Adapter
 * Switches between Alpha Vantage and Finnhub based on config
 */

import { API_PROVIDER } from '../config.js';
import * as AlphaVantage from './alphavantage.js';
import * as Finnhub from './finnhub.js';
import * as TwelveData from './twelve_data.js';

export async function fetchStockData(symbol, period, forceRefresh) {
    if (API_PROVIDER === 'finnhub') {
        return Finnhub.fetchStockData(symbol, period, forceRefresh);
    } else if (API_PROVIDER === 'twelvedata') {
        return TwelveData.fetchStockData(symbol, period, forceRefresh);
    } else {
        return AlphaVantage.fetchStockData(symbol, period, forceRefresh);
    }
}
